import type {IUserRepository, UserFilters} from '../../domain/repositories/IUserRepository';
import type {User, UserCreateParams, UserUpdateParams} from '../../domain/entities/User';

export class UserRepository implements IUserRepository {
    create(_user: UserCreateParams): Promise<User> {
        throw new Error("Method not implemented.");
    }

    findById(_id: string): Promise<User | null> {
        throw new Error("Method not implemented.");
    }

    findByEmail(_email: string): Promise<User | null> {
        throw new Error("Method not implemented.");
    }

    findByAuthId(_authId: string): Promise<User | null> {
        throw new Error("Method not implemented.");
    }

    findByPhoneNumber(_phoneNumber: string): Promise<User | null> {
        throw new Error("Method not implemented.");
    }

    update(_id: string, _updates: UserUpdateParams): Promise<User> {
        throw new Error("Method not implemented.");
    }

    delete(_id: string): Promise<void> {
        throw new Error("Method not implemented.");
    }

    exists(_id: string): Promise<boolean> {
        throw new Error("Method not implemented.");
    }

    findAll(_filters?: UserFilters): Promise<User[]> {
        throw new Error("Method not implemented.");
    }

}
